// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addSave_btn {\n  background-color: #213046 !important;\n  font-size: 12px !important;\n  color: #ffffff;\n  border-width: 0px;\n  padding: 7px;\n  width: 137px;\n  text-align: center !important; }\n\n.addeEdit_btn {\n  background-color: #213046 !important;\n  font-size: 12px !important;\n  color: #ffffff;\n  border-width: 0px;\n  padding: 7px;\n  width: 90px; }\n", ""]);
// Exports
module.exports = exports;
